import useController from '@common/hooks/useController'

// Native shim — match web context shape { state, currentDapp, isLoadingCurrentDapp }.
export default function useDappsControllerState(): any {
  const { state } = useController('DappsController' as any)
  return {
    state: state || {},
    currentDapp: null,
    isLoadingCurrentDapp: false
  }
}
